import { render, staticRenderFns } from "./UiTextArea.vue?vue&type=template&id=38931629&scoped=true"
import script from "./UiTextArea.vue?vue&type=script&lang=js"
export * from "./UiTextArea.vue?vue&type=script&lang=js"
import style0 from "./UiTextArea.vue?vue&type=style&index=0&id=38931629&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38931629",
  null
  
)

export default component.exports